import { Component, OnInit, ViewChild } from '@angular/core';
import { EnumeratorList } from '../../models/enumerators-list';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { UtilityService } from '../../services/utility-service';
import { LedgerHeadMaster } from '../../models/ledger-head-master-model';
import { LedgerHeadService } from '../../services/ledger-head-service';
import { AccountsMastersService } from '../../services/accounts-masters-service';

@Component({
  selector: 'app-ledger-head',
  templateUrl: './ledger-head.component.html',
  styleUrls: ['./ledger-head.component.css']
})
export class LedgerHeadComponent implements OnInit {
  public l_formData: LedgerHeadMaster = new LedgerHeadMaster();
  public entityTypeEnum: any[] = new EnumeratorList().entityTypeEnum;
  public l_isdeemedLabel: string = 'Deemed Positive';
  public l_isdeemed: boolean = false;
  public dataSource = new MatTableDataSource<LedgerHeadMaster>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public l_creditToList: LedgerHeadMaster[] = [];
  public l_daybookFilteredList: LedgerHeadMaster[] = [];
  public displayedColumns: string[] = ['name', 'entryType', 'isDeemedPositive', 'approvalStatus', 'actions'];


  constructor(
    private l_UtilityService: UtilityService,
    private l_AccountsMasterService: AccountsMastersService
  ) { }

  ngOnInit(): void {
    this.lFN_GetLedgerHeadAccounts();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  lFN_OnToggleChange(event: any) {
    this.l_isdeemed = event.checked;
    console.log('this.l_isUnmapped == ', this.l_isdeemed);
    if (this.l_isdeemed === true) {
      this.l_isdeemedLabel = 'Deemed Positive';
    }
  }

  async lFN_GetLedgerHeadAccounts() {
    let l_purposeLedgerMapList = this.l_AccountsMasterService.lFN_GetLedgerHeadsMasterList();
    l_purposeLedgerMapList.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_filteredList: LedgerHeadMaster[] = [];
          for await (const l_purposeledgerheadmap of JSON.parse(data.body)) {
            let l_mapobject = new LedgerHeadMaster(l_purposeledgerheadmap);
            l_filteredList.push(l_mapobject);
          }
          //console.log('l_filteredList === ', l_filteredList);
          l_filteredList.sort();
          this.dataSource.data = l_filteredList;
          this.l_UtilityService.lFN_HideLoader();

          this.l_creditToList = l_filteredList;
          this.l_daybookFilteredList = l_filteredList;

          this.l_UtilityService.lFN_HideLoader();
          await this.lFN_FilterDaybookDetails();
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch purpose ledgerhead mapping list', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_viewLedgerHead(l_event: any) {
    console.log('lFN_ViewMapping l_event === ', l_event);
  }

  async lFN_ApproveMapping(l_event: any) {
    console.log('lFN_ApproveMapping l_event === ', l_event);
    let l_approvalMasterResponse = this.l_AccountsMasterService.lFN_ApprovePurposeMappingMaster(l_event);
    l_approvalMasterResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          this.l_UtilityService.lFN_SuccessToaster('Accounts Purpose Ledger Master Mapping approved successfully', 'Approved Successfully');
          await this.lFN_GetLedgerHeadAccounts();
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster('Unable to approve purpose ledgerhead mapping list', 'Something went wrong');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_FilterDaybookDetails() {
    let l_filteredList = this.l_daybookFilteredList.filter(ledgerheadrow => {
      let l_status = true;

      if (this.l_formData.name) {
        if (!(ledgerheadrow.name.toLowerCase().includes(this.l_formData.name.toLowerCase()))) {
          l_status = false;
        }
      }
      else if (this.l_formData.entryType) {
        if (!(ledgerheadrow.entryType.toLowerCase().includes(this.l_formData.entryType.toLowerCase()))) {
          l_status = false;
        }
      }
      else if (this.l_formData.status) {
        if (!(ledgerheadrow.status.toLowerCase().includes(this.l_formData.status.toLowerCase()))) {
          l_status = false;
        }
      }

      return l_status;
    });
    this.dataSource.data = l_filteredList;
  }
}